const getters = {
    pickerOptions: state => state.app.pickerOptions, // 日期选择器数据
    checkNodeData: state => state.area.checkNodeData, // 选中节点的对象数据
    areaAllList: state => state.area.areaAllList, // 城市树结构全部数据
    checkAreaListID: state => state.area.checkAreaListID, // 城市选中的数据id
    paginObj: state => state.area.paginObj, // 城市选中的数据id
    statusList: state => state.user.statusList, // 用户访问状态： 如已到访
    userInfo: state => state.user.userInfo, // 用户信息，id和角色
    yulanImgList: state => state.chat.yulanImgList, // 预览图片
    roleList: state => state.role.roleList,
    menuList: state => state.role.menuList,
    operationList: state=> state.role.operationList,//用户拥有的操作权限列表
}
export default getters;
